import { render } from "./cluster-pod-security-standard.vue?vue&type=template&id=5503051e"
import script from "./cluster-pod-security-standard.vue?vue&type=script&lang=js"
export * from "./cluster-pod-security-standard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__